/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import { LoadingButton } from '@mui/lab'
import {
    Box,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Slide,
    Stack,
} from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { forwardRef, useState } from 'react'
import * as Sentry from '@sentry/react'
import { ReactComponent as UpdateVector } from '../../assets/images/update-vector.svg'

const Transition = forwardRef(
    (
        props: TransitionProps & {
            children: React.ReactElement<any, any>
        },
        ref: React.Ref<unknown>
    ) => <Slide direction="up" ref={ref} {...props} />
)

interface IProps {
    open: boolean
    toggle: () => void
    registration?: ServiceWorker
}
export default function UpdateModal(props: IProps) {
    const { open, toggle, registration } = props

    // State
    const [loading, setLoading] = useState(false)

    // Functions
    const updateApp = async () => {
        try {
            setLoading(true)
            const reg = await navigator.serviceWorker.ready

            if (reg.waiting) {
                reg.waiting.postMessage({
                    type: 'SKIP_WAITING',
                })

                window.location.reload()
            }
        } catch (error) {
            Sentry.captureException(`Update Error : ${error}`)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={toggle}
            aria-describedby="update-modal"
            sx={{ zIndex: 10000 }}
        >
            <DialogTitle>نسخه جدید</DialogTitle>
            <Box py={2} px={4}>
                <UpdateVector />
            </Box>
            <DialogContent>
                <DialogContentText id="update-modal">
                    نسخه جدیدی از برنامه در دسترس است. برای تجربه استفاده بهتر
                    لطفا برنامه را بروزرسانی کنید.
                </DialogContentText>
            </DialogContent>

            <Stack width="100%" direction="row" px={5} py={2}>
                <LoadingButton
                    fullWidth
                    loading={loading}
                    variant="contained"
                    color="primary"
                    onClick={updateApp}
                >
                    بروزرسانی
                </LoadingButton>
            </Stack>
        </Dialog>
    )
}
